import { render, staticRenderFns } from "./UserIdentity.vue?vue&type=template&id=b66f41ea&scoped=true&"
import script from "./UserIdentity.vue?vue&type=script&lang=js&"
export * from "./UserIdentity.vue?vue&type=script&lang=js&"
import style0 from "./UserIdentity.vue?vue&type=style&index=0&id=b66f41ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66f41ea",
  null
  
)

export default component.exports